import { TFunction } from 'i18next'

import type { Language } from '~/stores/settings'

export const getFirstInputPlaceholder = (isOnline: boolean, t: TFunction, sourceLanguage: Language) => {
  if (!sourceLanguage) return ''

  return isOnline ? t('Enter text using selected languages') : t('Enter Lang text', { lang: sourceLanguage.label })
}

export const getSecondInputPlaceholder = (isOnline: boolean, t: TFunction, learnLanguage: Language) => {
  if (!learnLanguage) return ''

  return isOnline ? t('Choose or enter translation') : t('Enter Lang text', { lang: learnLanguage.label })
}

// Determine file extension from mimeType
// Different browsers use different formats:
// - Chrome/Edge: audio/webm -> .webm
// - Firefox: audio/ogg -> .ogg
// - Safari/iOS: audio/mp4 -> .m4a or audio/aac -> .aac
export const getAudioFileExtension = (mimeType: string) => {
  if (mimeType.includes('webm')) return 'webm'

  if (mimeType.includes('ogg')) return 'ogg'

  if (mimeType.includes('mp4')) return 'm4a'

  if (mimeType.includes('aac')) return 'aac'

  return 'webm' // default fallback
}
